import React, { useMemo } from  "react";
import { publicRoutes } from "../../routePaths";
import { Switch, Route, useParams } from "react-router";
import PublicFormContainer from "./PublicFormContainer";
import PromiseWait from "../shared/PromiseWait";
import { getPublicPrefillData, getPublicTemplateList} from "../../stores/formsStore";
import { TenantInstallationIdProvider } from "../shared/useTenantInstallationId";
import PublicFormMenuPage from './PublicFormMenuPage';

const PublicFormsBaseRoute: React.FC = () => {

  const { tiid } = useParams<{tiid: string}>();
  const promises = useMemo(() => Promise.all([getPublicTemplateList(tiid), getPublicPrefillData(tiid)]), [tiid]);

  return (
    <PromiseWait promise={promises}>
      {([templates, prefillData]) => {
        return (
          <TenantInstallationIdProvider value={tiid} >
            <Switch>
              <Route exact path={publicRoutes.forms.view} component={PublicFormContainer} />
              <Route render={() =>
                // <PublicFormMenuPage tiid={tiid} templates={templates} header={<H3 style={{ flex: 1 }} />} />}
                <PublicFormMenuPage templates={templates} prefillData={prefillData}/>}
              />
            </Switch>
          </TenantInstallationIdProvider>
        );
      }}
    </PromiseWait>
  );
}


export default PublicFormsBaseRoute;
